module.exports = __webpack_public_path__ + "static/media/Trial1.95471979.mp3";